import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { useDragDropAnswerContext } from './DragDropAnswerContext';
import { MultipleDropSlot } from './MultipleDropSlot';
import { SingleDropSlot } from './SingleDropSlot';

export type DropSlotProps = {
  id: string;
  inline?: boolean;
  ariaLabel?: string;
  className?: string;
};

export function DropSlot(props: DropSlotProps) {
  const { capacityOf } = useDragDropAnswerContext();
  const isMultiple = capacityOf(props.id) === 'multiple';

  return (
    <ConditionalRenderer
      condition={isMultiple}
      fallback={<SingleDropSlot {...props} />}
    >
      <MultipleDropSlot {...props} />
    </ConditionalRenderer>
  );
}
